import { Tabs, TabsList, TabsTrigger, TabsContent } from '@radix-ui/react-tabs';
import { useState } from 'react';
import './styles.css';
import PincodeInput from './components/PincodeInput';

function App() {
  const [screen, setScreen] = useState('pincode');
  const [pincode, setPincode] = useState('');
  const [error, setError] = useState('');
  const [purchaseDeals, setPurchaseDeals] = useState([]);
  const [saleDeals, setSaleDeals] = useState([]);
  const [netStock, setNetStock] = useState(null);
  const [loading, setLoading] = useState(false);

  // Shared filter states
  const [selectedParty, setSelectedParty] = useState('');
  const [selectedVessel, setSelectedVessel] = useState('');
  const [hideCompleted, setHideCompleted] = useState(false);


  const validatePincode = async () => {
    try {
      const res = await fetch(`https://v3kgrnn0hc.execute-api.ap-south-1.amazonaws.com/prod/validateStockAppPin?pin=${pincode}`);
      const data = await res.json();
      if (data.message === 'Success') {
        setScreen('dashboard');
        setLoading(true);
        await fetchDeals();
        setLoading(false);
      } else {
        setError('Invalid Pincode');
      }
    } catch (e) {
      setError('Error validating pincode');
    }
  };

  const fetchDeals = async () => {
    const [saleRes, purchaseRes, netStockRes] = await Promise.all([
      fetch('https://v3kgrnn0hc.execute-api.ap-south-1.amazonaws.com/prod/getStockDeals?type=Sale'),
      fetch('https://v3kgrnn0hc.execute-api.ap-south-1.amazonaws.com/prod/getStockDeals?type=Purchase'),
      fetch('https://v3kgrnn0hc.execute-api.ap-south-1.amazonaws.com/prod/getNetStock')
    ]);

    const [saleData, purchaseData, netStockData] = await Promise.all([
      saleRes.json(),
      purchaseRes.json(),
      netStockRes.json()
    ]); 

    setSaleDeals(saleData.deals);
    setPurchaseDeals(purchaseData.deals);
    setNetStock(netStockData.stock || {});
  };

  const filterDeals = (deals) => {
    return deals.filter(deal =>
      (!selectedParty || deal.partyName === selectedParty) &&
      (!selectedVessel || deal.vessel === selectedVessel) &&
      (!hideCompleted || parseFloat(deal.balanceQty) > 0)
    );
  };

  const getUnique = (deals, field) => {
    return [...new Set(deals.map(deal => deal[field]))].sort((a, b) =>
      a.localeCompare(b)
    );
  };

  if (screen === 'pincode') {
    return (
      <PincodeInput
        pincode={pincode}
        setPincode={setPincode}
        validatePincode={validatePincode}
        error={error}
      />
    );
  }

  const allDeals = [...purchaseDeals, ...saleDeals];

  return (
    <div className="dashboard-container">
      <Tabs defaultValue="net" className="tabs">
        <TabsList className="tabs-list">
          <TabsTrigger value="net" className="tabs-trigger">Net Stock</TabsTrigger>
          <TabsTrigger value="purchase" className="tabs-trigger">Purchase</TabsTrigger>
          <TabsTrigger value="sale" className="tabs-trigger">Sale</TabsTrigger>
        </TabsList>

        {/* Shared Filters */}
        <div className="filters-container">
          <div className="filter-group">
            <label className="filter-label">Party</label>
            <select className="filter-dropdown" value={selectedParty} onChange={e => setSelectedParty(e.target.value)}>
              <option value="">All Parties</option>
              {getUnique(allDeals, 'partyName').map((name, idx) => (
                <option key={idx} value={name}>{name}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label className="filter-label">Vessel</label>
            <select className="filter-dropdown" value={selectedVessel} onChange={e => setSelectedVessel(e.target.value)}>
              <option value="">All Vessels</option>
              {getUnique(allDeals, 'vessel').map((name, idx) => (
                <option key={idx} value={name}>{name}</option>
              ))}
            </select>
          </div>

          <div className="filter-group checkbox-group">
            <label className="filter-label">
              <input
                type="checkbox"
                checked={hideCompleted}
                onChange={e => setHideCompleted(e.target.checked)}
              />
              Hide Completed Deals
            </label>
          </div>
        </div>

        {/* Loading Indicator */}
        {loading ? (
          <div className="loading-indicator">
            <p>Loading...</p>
          </div>
        ) : (
          <div>
            {/* NET STOCK TAB */}
            <TabsContent value="net" className="tabs-content">
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>US HIGH CV</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>Vessel</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {netStock['US HIGH CV'].vessels.map((vessel, idx) => (
                      <tr key={idx}>
                        <td>{vessel.name}</td>
                        <td>{vessel.quantity}</td>
                      </tr>
                    ))}
                    <tr key='ush-total'>
                        <th>Total</th>
                        <th>{netStock['US HIGH CV'].total}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br></br>
              <br></br>
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>US LOW CV</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>Vessel</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {netStock['US LOW CV'].vessels.map((vessel, idx) => (
                      <tr key={idx}>
                        <td>{vessel.name}</td>
                        <td>{vessel.quantity}</td>
                      </tr>
                    ))}
                    <tr key='ush-total'>
                        <th>Total</th>
                        <th>{netStock['US LOW CV'].total}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br></br>
              <br></br>
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>OTHERS</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>Vessel</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {netStock['OTHERS'].vessels.map((vessel, idx) => (
                      <tr key={idx}>
                        <td>{vessel.name}</td>
                        <td>{vessel.quantity}</td>
                      </tr>
                    ))}
                    <tr key='ush-total'>
                        <th>Total</th>
                        <th>{netStock['OTHERS'].total}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
             <br></br>
              <br></br>
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>FUTURE</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>Vessel</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {netStock['FUTURE'].vessels.map((vessel, idx) => (
                      <tr key={idx}>
                        <td>{vessel.name}</td>
                        <td>{vessel.quantity}</td>
                      </tr>
                    ))}
                    <tr key='ush-total'>
                        <th>Total</th>
                        <th>{netStock['FUTURE'].total}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabsContent>

            {/* PURCHASE TAB */}
            <TabsContent value="purchase" className="tabs-content">
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Party Name</th>
                      <th>Date</th>
                      <th>Lifting Days</th>
                      <th>Vessel</th>
                      <th>Rate</th>
                      <th>Total Quantity</th>
                      <th>Lifted Quantity</th>
                      <th>Balance Quantity</th>
                      <th>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterDeals(purchaseDeals).map((deal, idx) => (
                      <tr key={idx}>
                        <td>{deal.sno}</td>
                        <td>{deal.partyName}</td>
                        <td>{deal.date}</td>
                        <td>{deal.liftingDays}</td>
                        <td>{deal.vessel}</td>
                        <td>{deal.rate}</td>
                        <td>{deal.totalQuantity}</td>
                        <td>{deal.liftedQty}</td>
                        <td>{deal.balanceQty}</td>
                        <td>{deal.comments}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </TabsContent>

            {/* SALE TAB */}
            <TabsContent value="sale" className="tabs-content">
              <div className="deals-table">
                <table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Party Name</th>
                      <th>Date</th>
                      <th>Lifting Days</th>
                      <th>Vessel</th>
                      <th>Rate</th>
                      <th>Total Quantity</th>
                      <th>Lifted Quantity</th>
                      <th>Balance Quantity</th>
                      <th>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterDeals(saleDeals).map((deal, idx) => (
                      <tr key={idx}>
                        <td>{deal.sno}</td>
                        <td>{deal.partyName}</td>
                        <td>{deal.date}</td>
                        <td>{deal.liftingDays}</td>
                        <td>{deal.vessel}</td>
                        <td>{deal.rate}</td>
                        <td>{deal.totalQuantity}</td>
                        <td>{deal.liftedQty}</td>
                        <td>{deal.balanceQty}</td>
                        <td>{deal.comments}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </TabsContent>
          </div>
        ) }
      </Tabs>
    </div>
  );
}

export default App;
